import React from 'react'

import {
  FieldSpec,
  LinkedField,
  PaginatedTable,
  ValueField,
} from 'src/components/Table'
import { ListTableProps } from './types'

const fieldOptions: { [key:string]: FieldSpec } = {
  name: { id: 'name', label: 'Name', renderer: LinkedField(ValueField) },
}

export const MarketListTable = (props: ListTableProps) => {
  const { paginator, fields, exportConfig } = props

  return (
    <>
      <PaginatedTable
        title="Markets"
        fields={fields.map((field) => fieldOptions[field])}
        paginator={paginator}
        exportConfig={exportConfig}
      />
    </>
  )
}
